/* JF product page (sections/jf-pdp.liquid): option tiles, add-ons, running total, cart, art swap, Move Lab setup.
   Console option modes: 'upgrade' adds a second product to the cart (MICRO); 'sibling' swaps this product for its other version (SWORL, SLIDER). */
(function () {
  var root = document.querySelector('[data-jfp]');
  if (!root || root.__jfp) return;
  root.__jfp = 1;
  var D = root.dataset;
  var C = {
    mode: D.mode || (D.hasUp === 'true' ? 'upgrade' : 'none'),
    base: Number(D.base) || 0, up: Number(D.up) || 0, baseId: Number(D.baseId) || 0, upId: Number(D.upId) || 0,
    a: Number(D.a) || 0, aId: Number(D.aId) || 0, b: Number(D.b) || 0, bId: Number(D.bId) || 0,
    optA: D.optA || 'PS5 + Xbox', optB: D.optB || 'Switch + PC',
    platA: D.platA || 'PS5, Xbox, Switch 1 & 2, PC, Steam Deck', platB: D.platB || 'Switch 1 & 2, PC, Steam Deck',
    noteA: D.noteA || '', noteB: D.noteB || '',
    hasUp: D.hasUp === 'true', preview: D.preview === 'true', avail: D.avail === 'true',
    name: D.name || '', short: D.short || '', fmt: D.fmt || '', add: D.add || '/cart/add', cart: D.cart || '/cart'
  };
  var SIB = C.mode === 'sibling';
  var DOT = ' ' + String.fromCharCode(183) + ' ', AP = String.fromCharCode(39);
  function $(s, r) { return (r || root).querySelector(s); }
  function $$(s, r) { return [].slice.call((r || root).querySelectorAll(s)); }
  var reduce = false;
  try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}

  /* money, in the shop format, without trailing zeros */
  function group(s, sep) {
    var o = '';
    for (var i = 0; i < s.length; i++) { if (i && (s.length - i) % 3 === 0) o += sep; o += s.charAt(i); }
    return o;
  }
  function money(cents) {
    cents = Math.round(cents);
    var f = C.fmt.replace(/<[^>]*>/g, ''), a = f.indexOf('{{'), b = f.indexOf('}}'), ok = a >= 0 && b > a;
    var k = ok ? f.slice(a + 2, b) : 'amount', ts = ',', ds = '.';
    if (k.indexOf('comma_separator') >= 0) { ts = '.'; ds = ','; }
    if (k.indexOf('space_separator') >= 0) { ts = ' '; ds = ','; }
    if (k.indexOf('apostrophe') >= 0) { ts = AP; ds = '.'; }
    var dec = cents % 100, num;
    if (k.indexOf('no_decimals') >= 0) num = group(String(Math.round(cents / 100)), ts);
    else num = group(String(Math.floor(cents / 100)), ts) + (dec ? ds + (dec < 10 ? '0' : '') + dec : '');
    return ok ? f.slice(0, a) + num + f.slice(b + 2) : '$' + num;
  }

  /* add-ons */
  var HEX = { black: '#111318', orange: '#FF7F1A', 'sky blue': '#6EC6FF', purple: '#7B3FC4', lavender: '#B9A7E8', green: '#2FA84F', 'pastel blue': '#A9CCF5', pink: '#F49BC1', 'hot pink': '#FF2E88', grey: '#8A8F9C', gray: '#8A8F9C', 'chocolate brown': '#5A3A28', 'pure white': '#FFFFFF', white: '#FFFFFF', 'vanilla white': '#F3E9D2', red: '#D7263D', aqua: '#2EC4C6', yellow: '#FFD23F', 'royal blue': '#2B4FC4', blue: '#2B6FD6' };
  var addons = $$('[data-addon]').map(function (el) {
    var a = {
      el: el, on: false, ci: 0, single: el.hasAttribute('data-single'),
      name: el.getAttribute('data-ad-name') || '', note: el.getAttribute('data-ad-note') || '',
      input: $('[data-addon-toggle]', el), noteEl: $('[data-addon-note]', el), priceEl: $('[data-addon-price]', el), cols: $('.jfp-cols', el)
    };
    a.short = a.name.replace(/ set$/i, 's');
    a.note0 = a.noteEl.textContent;
    a.price0 = a.priceEl.textContent;
    a.colors = $$('.jfp-colbtn', el).map(function (b, i) {
      var c = { el: b, id: Number(b.getAttribute('data-v')), price: Number(b.getAttribute('data-c')), name: b.getAttribute('data-n') || '' };
      var hex = HEX[c.name.toLowerCase()];
      if (hex) $('i', b).style.background = hex;
      b.addEventListener('click', function () { a.ci = i; render(); });
      return c;
    });
    a.input.checked = false;
    a.input.addEventListener('change', function () { a.on = a.input.checked; render(); });
    return a;
  }).filter(function (a) { return a.colors.length; });

  /* state */
  var plat = SIB && D.cur === 'a' ? 'ps5' : 'base';
  function mainId() {
    if (SIB) return plat === 'ps5' ? C.aId : C.bId;
    return C.baseId;
  }
  function mainPrice() {
    if (SIB) return plat === 'ps5' ? C.a : C.b;
    return C.base;
  }
  function lines() {
    var L;
    if (SIB) L = [{ label: C.short + (C.hasUp ? DOT + (plat === 'ps5' ? C.optA : C.optB) : ''), price: mainPrice(), id: mainId() }];
    else {
      L = [{ label: C.short, price: C.base, id: C.baseId }];
      if (C.hasUp && plat === 'ps5') L.push({ label: C.optA + ' upgrade', price: C.up, id: C.upId, props: { 'Installs on': C.name } });
    }
    addons.forEach(function (a) {
      if (!a.on) return;
      var c = a.colors[a.ci];
      L.push({ label: a.short + (a.single ? '' : DOT + c.name), price: c.price, id: c.id });
    });
    return L;
  }
  function text(sel, t) { $$(sel).forEach(function (el) { el.textContent = t; }); }
  function render() {
    var ps5 = plat === 'ps5', L = lines(), total = 0;
    L.forEach(function (l) { total += l.price; });
    text('[data-price]', money(SIB ? mainPrice() : C.base + (ps5 ? C.up : 0)));
    if (C.hasUp) {
      if (SIB) text('[data-note]', ps5 ? C.noteA : C.noteB);
      else text('[data-note]', ps5 ? C.short + ' ' + money(C.base) + ' + ' + C.optA + ' upgrade ' + money(C.up) : C.noteB);
      text('[data-plat]', ps5 ? C.platA : C.platB);
      text('[data-bar-plays]', ps5 ? C.optA + ', ' + C.optB : C.optB);
      $$('[data-opt]').forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-opt') === plat ? 'true' : 'false'); });
    }
    var fid = $('[data-form-id]');
    if (fid) fid.value = String(mainId());
    addons.forEach(function (a) {
      var c = a.colors[a.ci];
      a.el.classList.toggle('on', a.on);
      a.cols.hidden = !a.on || a.single;
      a.noteEl.textContent = a.on && !a.single ? a.note + DOT + c.name : a.note0;
      a.priceEl.textContent = a.on ? '+' + money(c.price) : a.price0;
      a.colors.forEach(function (x, i) { x.el.setAttribute('aria-pressed', i === a.ci ? 'true' : 'false'); });
    });
    text('[data-total]', money(total)); text('[data-pi]', money(total / 4));
    var tally = $('[data-tally]');
    if (tally) {
      tally.textContent = '';
      L.forEach(function (l) {
        var li = document.createElement('li'), s = document.createElement('span'), p = document.createElement('strong');
        s.textContent = l.label;
        p.textContent = money(l.price);
        li.appendChild(s);
        li.appendChild(p);
        tally.appendChild(li);
      });
    }
    checkBar();
  }
  $$('[data-opt]').forEach(function (b) { b.addEventListener('click', function () { plat = b.getAttribute('data-opt'); render(); }); });

  /* in-page links */
  function go(id) {
    var t = document.getElementById(id);
    if (t) t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  }
  $$('a').forEach(function (a) {
    var h = a.getAttribute('href') || '';
    if (h.indexOf('#jfp-') !== 0) return;
    a.addEventListener('click', function (ev) {
      var p = a.getAttribute('data-pick');
      if (p) { plat = p; render(); }
      ev.preventDefault();
      go(h.slice(1));
    });
  });

  /* running tally bar: shows when the main button is less than half on screen or an add-on is ticked */
  var bar = $('[data-bar]'), cta = $('[data-cta]'), barOn = false, tick = 0;
  function checkBar() {
    if (!bar || !cta) return;
    var r = cta.getBoundingClientRect(), vh = window.innerHeight || document.documentElement.clientHeight || 0;
    var on = r.bottom <= 0 || r.top + r.height / 2 >= vh || addons.some(function (a) { return a.on; });
    var pb = document.getElementById('PBarNextFrameWrapper');
    bar.style.bottom = pb && pb.offsetHeight ? pb.offsetHeight + 'px' : '';
    if (on !== barOn) { barOn = on; bar.hidden = !on; }
    document.body.style.paddingBottom = barOn ? bar.offsetHeight + 'px' : '';
  }
  function later() { if (!tick) tick = requestAnimationFrame(function () { tick = 0; checkBar(); }); }
  window.addEventListener('scroll', later, { passive: true });
  window.addEventListener('resize', later);

  /* cart: every item goes in as its own line */
  var busy = false, msgEl = $('[data-msg]');
  function msg(t) { if (msgEl) { msgEl.textContent = t || ''; msgEl.hidden = !t; } }
  function setBusy(b) { busy = b; $$('[data-cta],[data-bar-add]').forEach(function (el) { el.classList.toggle('jfp-busy', b); }); }
  function add(opener) {
    if (busy || !C.avail) return;
    msg('');
    if (C.preview) {
      msg('Draft preview: the cart is off here until the PS5 + Xbox upgrade product and the new prices are live.');
      if (!cta || cta.getBoundingClientRect().top < 0) go('jfp-buy');
      return;
    }
    var items = lines().map(function (l) { var o = { id: l.id, quantity: 1 }; if (l.props) o.properties = l.props; return o; });
    if (items.some(function (i) { return !i.id; })) { msg('That option is not available right now.'); return; }
    items.reverse();
    var drawer = document.getElementById('Cart-Drawer');
    var useDrawer = !!drawer && !drawer.hasAttribute('data-status-silence') && typeof drawer.show === 'function' && typeof SectionDynamicUpdate !== 'undefined';
    var secs = [{ id: 'Cart-Icon-Bubble', section: 'cart-icon-bubble', selector: '.shopify-section' }];
    if (useDrawer) secs.push({ id: 'Cart-Drawer', section: drawer.dataset.section, selector: '#Cart-Drawer-Details' });
    var body = { items: items };
    if (useDrawer) { body.sections = secs.map(function (s) { return s.section; }); body.sections_url = window.location.pathname; }
    setBusy(true);
    fetch(C.add + '.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res.status) { msg(res.description || res.message || 'That could not be added to your cart.'); return; }
        if (useDrawer) {
          try {
            SectionDynamicUpdate.updateSections(secs, res.sections);
            if (typeof webvista !== 'undefined' && typeof PUB_SUB_EVENTS !== 'undefined') webvista.publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(mainId()), cartData: res });
            drawer.show(opener);
            return;
          } catch (e) {}
        }
        window.location.href = C.cart;
      })
      .catch(function () { msg('That could not be added to your cart. Please try again.'); })
      .then(function () { setBusy(false); });
  }
  var form = $('[data-form]');
  if (form) form.addEventListener('submit', function (ev) { ev.preventDefault(); add(cta); });
  var barAdd = $('[data-bar-add]');
  if (barAdd) barAdd.addEventListener('click', function () { add(barAdd); });

  /* photos */
  var gal = $('[data-gal]');
  $$('[data-gal-go]').forEach(function (b) {
    b.addEventListener('click', function () {
      if (gal) gal.scrollBy({ left: Number(b.getAttribute('data-gal-go')) * Math.max(240, gal.clientWidth * 0.7), behavior: reduce ? 'auto' : 'smooth' });
    });
  });

  /* art under the lid: just rotates */
  var art = $('[data-art]');
  if (art && !reduce) setInterval(function () { art.setAttribute('data-a', (Number(art.getAttribute('data-a')) + 1) % 5); }, 3600);

  /* Move Lab: the theme lab widget, set up for this page (styles come from the template in the section) */
  function setupLab() {
    var host = $('[data-jfp-lab]');
    if (!host || host.__jfpLab) return;
    if (window.JFMoveLab && !host.shadowRoot) { try { window.JFMoveLab.mount(host); } catch (e) {} }
    var sr = host.shadowRoot;
    if (!sr) return;
    host.__jfpLab = 1;
    var q = function (s) { return sr.querySelector(s); };
    var css = $('[data-jfp-labcss]');
    if (css && css.content) sr.appendChild(css.content.cloneNode(true));
    var L = window.__lab, M = L && L.MOVES;
    if (M && M.length && M[M.length - 1].id === 'evo37') {
      var gone = M.pop(), btns = sr.querySelectorAll('#moves button');
      if (btns.length === M.length + 1) btns[btns.length - 1].remove();
      [].forEach.call(sr.querySelectorAll('#filter button'), function (b, i) {
        var n = b.querySelector('i');
        if (i === 0 && n) n.textContent = M.length;
        if (b.textContent.indexOf(gone.game) === 0) b.hidden = true;
      });
    }
    var count = q('#morecount');
    if (count && M) count.textContent = M.length + ' moves' + DOT + 'speed' + DOT + 'notes';
    var tip = q('#tip'), setup = q('.setup');
    if (tip && setup) setup.appendChild(tip);
    var tv = q('#tv'), rig = q('#rigbox'), what = q('#what'), tail = ' leverless FGC fight stick controller';
    function label() {
      var mv = what ? what.textContent : 'a move';
      if (tv) tv.setAttribute('aria-label', C.name + tail + ' Move Lab: an orange stick figure performs ' + mv + ' on a grey one');
      if (rig) { rig.setAttribute('role', 'img'); rig.setAttribute('aria-label', C.name + tail + ' seen from the player' + AP + 's side, with the buttons for ' + mv + ' lighting up in order'); }
    }
    if (tv) tv.textContent = 'Animated stick figures showing fighting game moves as they are entered on the ' + C.name + tail + '.';
    label();
    if (what && window.MutationObserver) new MutationObserver(label).observe(what, { childList: true, characterData: true, subtree: true });
    if (reduce && L && L.pause) { try { L.pause(); } catch (e) {} }
    try { window.dispatchEvent(new Event('resize')); } catch (e) {}
  }

  render();
  setupLab();
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setupLab);
  window.addEventListener('load', function () { setupLab(); checkBar(); });
})();
